import { render, staticRenderFns } from "./disasterOfficersList.vue?vue&type=template&id=d24eeb96&scoped=true"
import script from "./disasterOfficersList.vue?vue&type=script&lang=js"
export * from "./disasterOfficersList.vue?vue&type=script&lang=js"
import style0 from "./disasterOfficersList.vue?vue&type=style&index=0&id=d24eeb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24eeb96",
  null
  
)

export default component.exports